async function fetchProductDetails(producthandle) {
  const STOREFRONT_ACCESS_TOKEN = '8be2e22fb6cffb8392b3a091157aea39';
  const url = `https://${document.location.hostname}/api/2024-07/graphql.json`;
  const query = `
  {
    product(handle: "${producthandle}") {
      title
      availableForSale
      variants(first: 2) {
        edges {
          node {
            id
            quantityAvailable
          }
        }
      }
      metafield(namespace: "custom", key: "acu_product_allow_back_order") {
        value
      }
    }
  }`;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN, // Storefront Access Token
    },
    body: JSON.stringify({ query })
  });

  const result = await response.json();
  //console.log('response:', JSON.stringify(result, null, 2));

  // Ensure product data is present
  const product = result.data && result.data.product;

  if (product) {
    // Check conditions for each variant
    const hasZeroStockAndContinuesSelling = product.variants.edges.some(variant => {
      return variant.node.quantityAvailable <= 0 && product.availableForSale;
    });

    
    // Check if the metafield is set to "true" (or the equivalent boolean value)
    const metafieldEnabled = product.metafield && product.metafield.value === "true";

    // Apply styling if all conditions are met
    if (hasZeroStockAndContinuesSelling && metafieldEnabled) {
      const stockStatus = document.querySelector('#product-form-stock');
      if (stockStatus) {
        var backOrderAvailability = document.getElementById('back_order_availability_message').value;
         stockStatus.textContent = backOrderAvailability;
         stockStatus.classList.add('stock-status');
      }
      
      const pickupDetailsDiv = document.querySelector('.store-pickup-details');
      if (pickupDetailsDiv) {
        pickupDetailsDiv.style.display = 'none';
      }
      
      const pickupDetailslink = document.querySelector('.store-availability-container');
      if (pickupDetailslink) {
        pickupDetailslink.style.display = 'none';
      }

      const button1 = document.querySelector('.product-form__add-button');
      if (button1) {
          button1.innerText = 'Back Order';
      }
      //const button2 = document.querySelector('.product-item__action-button');
      //if (button2) {
        //  button2.innerText = 'Back Order';
      //}
    }else{
      const pickupDetailsDiv = document.querySelector('.store-pickup-details');
      if (pickupDetailsDiv) {
        pickupDetailsDiv.style.display = 'block';
      }
    }

    return product; // Return the product object
  } else {
      const pickupDetailsDiv = document.querySelector('.store-pickup-details');
      if (pickupDetailsDiv) {
        pickupDetailsDiv.style.display = 'block';
      }
    //console.error('Product not found or data is missing.');
    return null;
  }
}

// Main code to parse the specifications, fetch product details, and display them
async function main() {
  const productDetails = await fetchProductDetails(producthandle);
  //console.log('Product Details:', productDetails);
}

// Call the main function to execute the above steps
main();
